module.exports = __webpack_public_path__ + "img/icon_map_2_yj.06349ca7.png";